import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  SegmentConnectionComponent
} from '@shared/flight-segment-connection/components/segment-connection/segment-connection.component';
import {
  FlightSegmentConnectionComponent
} from '@shared/flight-segment-connection/components/flight-segment-connection/flight-segment-connection.component';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { AlertDsComponent } from '@design-system/components/molecules/alert/alert.component';

@NgModule({
  declarations: [
    FlightSegmentConnectionComponent,
    SegmentConnectionComponent
  ],
  imports: [
    CommonModule,
    AlertDsComponent,
    GlobalPipesModule
  ],
  exports: [
    FlightSegmentConnectionComponent,
    SegmentConnectionComponent
  ]
})
export class FlightSegmentConnectionModule { }
